import { slugify } from "./slugify"

/** Keys owned by this app in localStorage */
export const PULPIT_STORAGE_KEYS = {
  TRIP_DATA: "tripData",
  CAB_SEARCH_RESULT: "cabSearchResult",
  PREFILL_FROM_CITY: "pulpit_prefill_from_city",
  RECENT_SEARCHES: "pulpit_recent_searches",
}

export function clearSessionStorageSafe() {
  try {
    if (typeof sessionStorage !== "undefined") sessionStorage.clear()
  } catch (_) {
    /* ignore */
  }
}

export function removeCabSearchResult() {
  try {
    localStorage.removeItem(PULPIT_STORAGE_KEYS.CAB_SEARCH_RESULT)
  } catch (_) {
    /* ignore */
  }
}

export function removeTripData() {
  try {
    localStorage.removeItem(PULPIT_STORAGE_KEYS.TRIP_DATA)
  } catch (_) {
    /* ignore */
  }
}

export function removePrefillFromCity() {
  try {
    localStorage.removeItem(PULPIT_STORAGE_KEYS.PREFILL_FROM_CITY)
  } catch (_) {
    /* ignore */
  }
}

/** tripData + cabSearchResult (booking / fare flow) */
export function clearBookingFlowStorage() {
  removeTripData()
  removeCabSearchResult()
}

/**
 * Full reset of app client storage. Use on payment success, logout-like flows, or session expiry redirect.
 * @param {{ keepRecentSearches?: boolean }} options
 */
export function clearAllPulpitClientStorage(options = {}) {
  const { keepRecentSearches = false } = options
  clearBookingFlowStorage()
  removePrefillFromCity()
  if (!keepRecentSearches) {
    try {
      localStorage.removeItem(PULPIT_STORAGE_KEYS.RECENT_SEARCHES)
    } catch (_) {
      /* ignore */
    }
  }
  clearSessionStorageSafe()
}

/**
 * Whether stored outstation trip matches route URL slugs (e.g. ahmedabad → vadodara).
 */
export function tripDataMatchesRouteSlugs(tripParsed, fromSlug, toSlug) {
  if (!tripParsed || tripParsed.trip_type !== 3 || !fromSlug || !toSlug) return false
  const pf = slugify(String(tripParsed.pickup_city || "").trim())
  const pt = slugify(String(tripParsed.drop_city || "").trim())
  const a = String(fromSlug).toLowerCase().trim()
  const b = String(toSlug).toLowerCase().trim()
  return pf === a && pt === b
}

/**
 * Parse tripData from localStorage or return null.
 */
export function readTripDataParsed() {
  try {
    const raw = localStorage.getItem(PULPIT_STORAGE_KEYS.TRIP_DATA)
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

/**
 * Call when entering a /routes/:from-to-to-cab page. Clears sessionStorage always;
 * clears booking storage if trip does not match this route; always drops stale cabSearchResult.
 */
export function reconcileStorageForRoutePage(fromSlug, toSlug) {
  clearSessionStorageSafe()
  removeCabSearchResult()

  const parsed = readTripDataParsed()
  const match = tripDataMatchesRouteSlugs(parsed, fromSlug, toSlug)

  if (!match) {
    clearBookingFlowStorage()
  }

  return { matchedRoute: match }
}
